export default "__VITE_ASSET__zZO5kNz2__"